// @flow

import type {ApplicationState} from '../../types'
import {createSelector} from 'reselect'

import {getPagination} from './getPagination'

export function getNextPage(appState: ApplicationState): ?Url{
  return _getNextPage(appState.place) 
}

const _getNextPage = createSelector(
  [getPagination.internal],
  (pagination: ?PaginationResponse<PartnerPlace>) => {
    if (!pagination) return null
    return pagination._links.next
  }
)

getNextPage.internal = _getNextPage
